import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import { Typography, useMediaQuery, useTheme } from "@mui/material";
import Parser from "html-react-parser";

// import { mainStyles, theme } from '../../styles'
import { useStyles } from "./IdentityValidationStyles";
import {
  documentsActions,
  fileActions,
  workflowActions,
} from "../../store/actions";
import {
  GenericContainer,
  UseImage,
  CustomLoadingOverlay,
  Buttons,
  GeoLocationGeneric,
} from "../../components";
import {
  useProjectContext,
  ApiFatechUrl,
  ApiUrl,
  ApiIdentyUrl,
  coreFunctions,
} from "../../utils";
import help_selfie_successImg from "../../assets/help_selfie_success.jpg";
import help_selfie_captureImg from "../../assets/help_selfie_capture.jpg";
import MujerLivenessImg from "../../assets/MujerLiveness.jpg";
import { useTranslation } from "react-i18next";

export default function HelpSelfie(props) {
  const theme = useTheme();
  const location = useLocation();
  const matches = useMediaQuery("(max-width:812px)");
  const context = useProjectContext();
  const localStyles = useStyles();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [b64, setB64] = useState("");
  const [timeStamp, setTimeStamp] = useState("");
  const [folio, setFolio] = useState("");
  const [sectionId, setSectionId] = useState("");

  const [sections, setSections] = useState([]);
  const [docName, setDocName] = useState("");
  const [actorId, setActorId] = useState(0);

  // const [clickNewTab, setClickNewTab] = useState(false)
  const [showFirstText, setShowFirstText] = useState(true);
  const [falsePopUp, setFalsePopUp] = useState(false);
  const [popUp, setPopUp] = useState(false);
  const [loadView, setLoadView] = useState(false);

  const [activeGeolocation, setActiveGeolocation] = useState(true);
  const [latitude, setLatitude] = useState("-85.05112878");
  const [longitude, setLongitude] = useState("-180");
  const [loadSection, setLoadSection] = useState(false);
  const [loadFacial, setLoadFacial] = useState(false);
  const [docId, setDocId] = useState(0);
  const [metadataExtraccion, setMetadataExtraccion] = useState([]);
  const [activeFaceAIConsult, setActiveFaceAIConsult] = useState(false);
  const [captureSelfieSdk, setCaptureSelfieSdk] = useState(false);
  const [autoloadSelfie, setAutoloadSelfie] = useState(true);
  const { t } = useTranslation();

  const file = useSelector((state) => state.FileInfo);
  const uploadSecDoc = useSelector((state) => state.UploadSections);
  const facialResult = useSelector((state) => state.FacialComparison);
  const registroStatusStage = useSelector((state) => state.RegStatusStage);

  // const baseURL = "https://bttrwr-ftcss-lb-dev.koalavsp.com";
  // const baseURL = "https://smb-zcs-dev.koalavsp.com";
  const baseURL = ApiFatechUrl.ambientBase;
  const config = {
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json;charset=UTF-8",
    },
  };

  useEffect(() => {
    dispatch(
      workflowActions.RegisterStatusStage({
        File_id: location.state.folioId,
        Status: "ValidaciónFacial",
      })
    );

    dispatch(fileActions.GetFileInfo(location.state.folioId));
    let date = new Date();
    setTimeStamp(
      `${date.getFullYear()}${
        date.getMonth() + 1
      }${date.getDate()}${date.getHours()}${date.getMinutes()}${date.getSeconds()}`
    );
    console.log(
      "HelSelfie location.state.sections--- Facial -----------: ",
      location.state.sections
    );
    const selfieSection = location.state.sections.find(
      (sec) => sec.Name === "Selfie"
    );
    setSectionId(selfieSection.Id);
    setFolio(location.state.folioId);
    setSections(location.state.sections);
    setDocName(location.state.docName);
    setActorId(location.state.actorId);
    setMetadataExtraccion(location.state.metadataExtraccion);
    console.log("HelSelfie location.state*******: ", location.state);
    let base64Image = localStorage.getItem("selfiePruebaVida");
    console.log(
      "HelSelfie Baseg4Init: base64Image***************base64Image*******: ",
      base64Image
    );
    if (base64Image != undefined && base64Image != null && base64Image != "") {
      let img64Data = base64Image.replace("data:image/png;base64,", "");
      console.log(
        "HelSelfie Baseg4Init: base64Image***************base64Image*******: Entro IF",
        img64Data
      );
      setB64(img64Data);
      setLoadView(true);
      setAutoloadSelfie(true);
    }
  }, []);

  useEffect(() => {
    console.log("FileInfo*******: ", file.items);
    if (file.items != undefined && activeFaceAIConsult) {
      setFolio(file.items.Folio);
      setActiveFaceAIConsult(false);
      //Todo: obtener el dato correcto para comparar.
      setLoadSection(false);
      setLoadFacial(true);

      /////TODO: AJuste pendiente cuando se use FACEAI se debe ajustar arreglo como esta en comentado se agregara logica
      console.log(
        "************???????????*********????*************file.items.DocumentalCategories1111********: ",
        file.items.DocumentalCategories
      );
      let docIdFind =
        file.items.DocumentalCategories[0]?.DocumentalGroups?.find(
          (item) => item.Name == "Identificación oficial"
        )?.Documents?.find((item) => item.Name == "INE / IFE")?.Id;
      console.log(
        "************************Doc ID+********************************: ",
        docIdFind
      );

      //              // console.log(".????????????..........getSections----??????: ", data, " --dataStage- ", dataStage)
      //   let listDocumentFilter = dataStage?.DocumentalCategories.filter(item=> item.DocumentalGroups.some(itemDoc=> itemDoc.Documents != undefined))
      //   //  console.log(".????????????..........listDocumentFilter5--some--??????: ", listDocumentFilter)
      //    let objectDocument = listDocumentFilter?.map(item=> item.DocumentTypes?.filter(itemDoc=> itemDoc.Document != undefined)[0])[0]
      //   //  console.log(".????????????..........objectDocument10----??????: ", objectDocument)

      //   // let listDocument = dataStage?.DocumentalCategory?.DocumentalGroups[0]?.DocumentTypes?.filter(item => item.Document != null)
      //   // let nameFInd = listDocument != undefined && listDocument != null ? listDocument[listDocument.length - 1]?.Document?.Name : "DNI"
      //   let nameFInd = objectDocument?.Document?.Name

      context.setDocID(docIdFind);
      setDocId(docIdFind);
      dispatch(documentsActions.GetFacialComparison(docIdFind));
    } else if (file.items != undefined) {
      setFolio(file.items.Folio);

      let actGeoloc = file.items.Stage.Properties.find(
        (item) => item.Name == "ActiveGeolocation"
      )?.Value;
      // console.log("actGeoloc-----PARAM--- CONFIG------ ", actGeoloc)
      setActiveGeolocation(actGeoloc === undefined ? true : actGeoloc);
      let typeSelfieCapture = null;
      typeSelfieCapture = file.items.Metadata.find(
        (item) =>
          item.GroupName === "Face" && item.Name == "ManualCaptureSelfieSdk"
      )?.Value;
      console.log(
        "********************TYPE SELFIE****************** ",
        typeSelfieCapture
      );
      setCaptureSelfieSdk(typeSelfieCapture);
      if (
        typeSelfieCapture === undefined ||
        typeSelfieCapture === null ||
        typeSelfieCapture == ""
      ) {
        typeSelfieCapture = file.items.Stage.Properties.find(
          (item) => item.Name == "CaptureSelfieSdk"
        )?.Value;
        console.log(
          "********************TYPE SELFIE************typeSelfieCapture****** ",
          typeSelfieCapture
        );
        setCaptureSelfieSdk(typeSelfieCapture);
      }
    }
  }, [file]);

  let handleResponse = (response) => {
    console.log("response----fACETECH----------: ", response);
    let respObject = response.data; //BodySecurityResponse(response.data);
    setB64(respObject.data.auditTrailBase64);
  };

  const hanldeClick = () => {
    setShowFirstText(false);
    dispatch(
      workflowActions.RegisterStatusStage({
        File_id: folio,
        Status: "ValidaciónFacial",
      })
    );

    // if (true) {
    //     let folioId = folio
    //     // let docName = facialResult.items.Name
    //     // let documetId = facialResult.items.Id
    //     // // console.log("facialResult------2------------:Docname:---", docName)
    //     // let selfieMeta = facialResult.items.Metadata
    //     // let docIds = facialResult.items.Sections.filter(sec => !sec.Name.includes('Minucia')).map((secc) => secc.Id)

    //     const nextComponent = 'LifeTestComponent'
    //     identityValFunctions.nextIndocLoading({ navigate, nextComponent, folioId })

    // } else {

    // if (captureSelfieSdk == "FaceAI") {
    //     let wihe = 'width=' + window.screen.availWidth + ',height=' + window.screen.availHeight;
    //     let win = window.open(`${ApiIdentyUrl.faceAI}app?params=${folio}_${sectionId}_${latitude}_${longitude}_${encodeURI(ApiUrl.ambient)}_${sessionStorage.getItem('token')}`, '_blank', "screenX=1,screenY=1,left=1,top=1," + wihe);

    //     let pollTimer = window.setInterval(function () {
    //         console.log("Espea de cierre de ventana------------------- ", win?.closed)
    //         if (win.closed != false) { // != is required for compatibility with Opera
    //             window.clearInterval(pollTimer);

    //             console.log("Aqui se realiza la accion de consultar la selfie.")
    //             dispatch(fileActions.GetFileInfo(folio))
    //             setActiveFaceAIConsult(true)
    //         }
    //     }, 2000);
    // } else {
    //     let wihe = 'width=' + window.screen.availWidth + ',height=' + window.screen.availHeight;
    //     let win = window.open(`${ApiFatechUrl.ambient}?folioId=${folio}_${timeStamp}`, '_blank', "screenX=1,screenY=1,left=1,top=1," + wihe);

    //     let pollTimer = window.setInterval(function () {
    //         console.log("Espea de cierre de ventana------------------- ", win?.closed)
    //         if (win.closed != false) { // != is required for compatibility with Opera
    //             window.clearInterval(pollTimer);
    //             //Se obtiene para mandar a llamar el stage siguiente:
    //             setLoadView(true)
    //             console.log("Base url Facte tech: **************************", baseURL, "Params: ", `${baseURL}/enrollment-3d/ObDS_${folio}_${timeStamp}`, "   ----- config. ", config)
    //             return axios.get(`${baseURL}/enrollment-3d/ObDS_${folio}_${timeStamp}`, config).then(handleResponse)
    //         }
    //     }, 2000);
    // }
  };

  useEffect(() => {
    if (b64 != "") {
      const dataToSend = {
        // To UploadSection
        B64Content: b64,
        FileId: folio,
        Actor_Id: actorId,
        SkipActor: null,
        SectionId: sectionId,
        Extension: ".jpg",
        Skip: false,
        SkipReason: null,
        Metadata: [
          {
            GroupName: "FaceTec",
            Name: "EnrollmentID",
            Value: `ObDS_${folio}_${timeStamp}`,
          },
        ],
        ContinueWorkFlow: false, //to upload all files before moving if true would move to the next stage
        Geolocation: {
          Latitude: latitude,
          Longitude: longitude,
        },
        DeferLoad: false, // heavy file, true to load on backgroud
      };
      console.log(
        "sectionId----------send metadata-------------------: ",
        dataToSend
      );
      dispatch(documentsActions.CargaSeccion(dataToSend));
      setLoadSection(true);
    }
  }, [b64]);

  useEffect(() => {
    if (uploadSecDoc.items != undefined && loadSection) {
      console.log(
        "uploadSecDoc.items****************************: ",
        uploadSecDoc.items
      );
      console.log(
        "uploadSecDoc.items.Result?.Id*****************************: ",
        uploadSecDoc.items?.Result?.Id
      );
      setLoadSection(false);
      setLoadFacial(true);
      context.setDocID(uploadSecDoc.items?.Result?.Id);
      setDocId(uploadSecDoc.items?.Result?.Id);

      console.log("Valida pasaporte: ", docName);
      // if (docName == "Pasaporte") {
      //     let folioId = folio
      //      let docName = uploadSecDoc.items?.Result?.Name
      //     let documetId = uploadSecDoc.items?.Result?.Id
      //     // let selfieMeta = facialResult.items.Metadata
      //     // let docIds = facialResult.items.Sections.filter(sec => !sec.Name.includes('Minucia')).map((secc) => secc.Id)
      //     let nextStage = file.items.Stage
      //     let stageName = nextStage.Name
      //     let stageId = nextStage.Id
      //     let stage = file.items

      //     const nextComponent = 'ExtractionForm'
      //     identityValFunctions.nextIndocLoading({ navigate, stage, nextComponent, folioId, sections, docName, documetId, metadataExtraccion })

      // } else
      if (
        uploadSecDoc.items.Result?.Id != null ||
        uploadSecDoc.items.Result?.Id != undefined
      ) {
        dispatch(
          documentsActions.GetFacialComparison(uploadSecDoc.items.Result.Id)
        );
      }
    }
    if (uploadSecDoc.error != undefined && loadSection) {
      setLoadSection(false);
      alert(uploadSecDoc.error);
      console.log("Entro en carga de documentos: ", uploadSecDoc.error);
      setLoadView(false);
      window.location.reload(false);
    }
  }, [uploadSecDoc]);

  useEffect(() => {
    if (facialResult.items != undefined && loadFacial) {
      setLoadView(false);
      setLoadFacial(false);
      //salta el carrusel y manda directo a ocr
      if (true) {
        let folioId = folio;
        let docName = facialResult.items.Name;
        let documetId = facialResult.items.DocumentData.Id;
        let selfieMeta = facialResult.items.DocumentData.Metadata;
        // let docIds = facialResult.items.Sections?.filter(sec => !sec.Name.includes('Minucia'))?.map((secc) => secc.Id)
        let nextStage = file.items.Stage;
        // let stageName = nextStage.Name
        // let stageId = nextStage.Id
        let stage = file.items;

        const nextComponent = "ExtractionForm";
        coreFunctions.DoNextStage({
          navigate,
          nextComponent,
          State: {
            stage,
            folioId,
            sections,
            docName,
            documetId,
            selfieMeta,
            metadataExtraccion,
          },
        });
      } else {
        console.log("facialResult------1------------: ", facialResult.items);
        let folioId = folio;
        let docName = facialResult.items.Name;
        let documetId = facialResult.items.Id;
        let selfieMeta = facialResult.items.Metadata;
        let docIds = facialResult.items.Sections.filter(
          (sec) => !sec.Name.includes("Minucia")
        ).map((secc) => secc.Id);

        const nextComponent = "Carousel";
        console.log(
          "nextComponent, folioId, docName, selfieMeta, docIds, documetId: ",
          nextComponent,
          folioId,
          docName,
          selfieMeta,
          docIds,
          documetId
        );
        coreFunctions.DoNextStage({
          navigate,
          nextComponent,
          State: {
            folioId,
            docName,
            selfieMeta,
            docIds,
            documetId,
            metadataExtraccion,
          },
        });
      }
    } else if (facialResult.error != undefined && loadFacial) {
      alert(facialResult.error);
      setLoadView(false);
      setLoadFacial(false);
      window.location.reload(false);
    }
  }, [facialResult]);

  return (
    <GenericContainer>
      {activeGeolocation && (
        <GeoLocationGeneric
          SuccessFN={(latitude, longitude) => {
            console.log("succes,latitude, longitude ", latitude, longitude);
            setLatitude(latitude);
            setLongitude(longitude);
          }}
          ErrorFN={(error) => console.log("error", error)}
        />
      )}
      {loadView || autoloadSelfie ? (
        <CustomLoadingOverlay
          active={loadView || autoloadSelfie}
          text={loadView ? t("general_loading_message") : t("data_extraction")}
        />
      ) : (
        <>
          <div className={localStyles.textContent}>
            <Typography variant="h6" gutterBottom>
              <b>{t("applicant_biometrics")}</b>
            </Typography>
            <Typography
              variant={!matches ? "subtitle2" : "subtitle1"}
              gutterBottom
            >
              {popUp
                ? Parser(
                    "Se ha realizado exitosamente la captura de tu selfie, da click en el botón de continuar para ver el siguiente paso."
                  )
                : Parser(
                    "<b>Centra el rostro al óvalo y acerca el dispositivo cuando se te indique.</b> El rostro debe estar descubierto, sin lentes o gorra y con buena iluminación. Evita hacer gestos durante la captura."
                  )}
            </Typography>
          </div>
          {matches &&
          (navigator.userAgent.match(/Android/i) ||
            navigator.userAgent.match(/iPhone/i)) ? (
            <UseImage
              src={popUp ? help_selfie_successImg : help_selfie_captureImg}
              className={localStyles.imgHelp1}
            />
          ) : (
            <UseImage src={MujerLivenessImg} className={localStyles.imgHelp1} />
          )}
          <div>
            <Typography
              className={localStyles.instructiontoPopUp}
              variant={!matches ? "subtitle2" : "subtitle1"}
              gutterBottom
            >
              <b>{t("allows_open_windows")}</b>
            </Typography>
            {!popUp && showFirstText ? (
              <Buttons
                background_color={theme.palette.primary.main}
                text_color="#FFFFFF"
                border_color={theme.palette.primary.main}
                text={
                  showFirstText
                    ? t("capture_selfie")
                    : falsePopUp || (popUp && t("general_next"))
                }
                type="button"
                className={localStyles.cargarDocsBtn}
                click={hanldeClick}
              />
            ) : null}
          </div>
        </>
      )}
    </GenericContainer>
  );
}
